<template>
    <div :class="['reward-list', {
        isH5: isH5
    }]">
        <div class="list">
            <template v-if="list.length">
                <FoldBox
                    v-for="(item, index) in list"
                    :key="index"
                    class="item"
                >
                    <template v-slot:btn="{ fold, isFold }">
                        <div class="box">
                            <div class="left">
                                <div class="title">{{ item.title }}</div>
                                <a
                                    :class="['fold-btn', { 'is-fold': isFold }]"
                                    @click="fold"
                                >
                                    {{ i18n.detailBtn }}
                                </a>
                            </div>
                            <a
                                v-if="item.btnDisplay"
                                class="btn"
                                target="_blank"
                                :href="item.btnLink || 'javascript:;'"
                            >{{ item.btnText }}</a>
                        </div>
                    </template>
                    <div
                        slot="detail"
                        class="detail"
                    >
                        <div class="time">{{ formatTime(item.createTime) }}</div>
                        <div v-if="item.descDisplay" class="desc" v-html="item.desc" />
                    </div>
                </FoldBox>
            </template>
            <div v-else class="empty">
                {{ emptyText }}
            </div>
        </div>
    </div>
</template>
<script>
import { library } from '@futuweb/fego-bridge';
import { isH5 } from './utils';
import FoldBox from './FoldBox.vue';
import i18n, { AREA } from '../editor/i18n';

const { dayjs } = library;

export default {
    props: {
        emptyText: {
            type: String,
            default: 'No record'
        },
        language: {
            type: String,
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    components: {
        FoldBox
    },
    data() {
        return {
            isH5: isH5()
        }
    },
    computed: {
        i18n() {
            return i18n[AREA.US][this.language]
        }
    },
    methods: {
        formatTime(time) {
            return dayjs.unix(time).format('YYYY/MM/DD')
        },
    }
};
</script>
<style lang="less" scoped>
.reward-list {
    &.isH5 {
        .list {
            background-color: #fff;
            padding: 0.1rem 0.4rem 0.2rem;
            border-radius: 0.3rem;
            height: 100%;
            max-height: 8rem;
            overflow-y: auto;
            box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.05);
            .item {
                padding: 0.4rem 0 0.3rem;
                & + .item {
                    border-top: 0.01rem solid #9f9f9f;
                }
                .box {
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                }
            }
            .title {
                line-height: 0.5rem;
                font-size: 0.3rem;
                color: #262626;
            }
            .btn {
                position: relative;
                top: 0.1rem;
                margin-left: 0.2rem;
                flex-shrink: 0;
                line-height: 0.56rem;
                padding: 0 0.2rem;
                font-size: 0.22rem;
                color: #ff6900;
                min-width: 1.12rem;
                border-radius: 0.3rem;
                text-align: center;
                border: 0.02rem solid #ff6900;
            }
            .empty {
                padding: 0.7rem 0.4rem;
                text-align: center;
                line-height: 0.5rem;
                font-size: 0.3rem;
                color: #9f9f9f;
            }
            .fold-btn {
                line-height: 0.38rem;
                font-size: 0.24rem;
                color: #7a7a7a;
                &::after {
                    margin-left: 0.09rem;
                    position: relative;
                    top: -0.03rem;
                    content: '';
                    display: inline-block;
                    width: 0.16rem;
                    height: 0.10rem;
                    background: url('./image/arrow.png') no-repeat center;
                    background-size: contain;
                }
                &.is-fold {
                    &::after {
                        transform: rotate(180deg);
                    }
                }
            }
            .detail {
                margin-top: 0.12rem;
                padding: 0.22rem 0.4rem 0.3rem 0.65rem;
                background-color: #f8f8f8;
                border-radius: 0.2rem;
                border: 0.01rem solid #efefef;
                position: relative;
                &::before {
                    position: absolute;
                    top: -0.15rem;
                    left: 0.75rem;
                    content: '';
                    display: inline-block;
                    width: 0.27rem;
                    height: 0.27rem;
                    background: url('./image/triangle.png') no-repeat center;
                    background-size: contain;
                }
                .time, .desc {
                    line-height: 0.38rem;
                    font-size: 0.24rem;
                    color: #7a7a7a;
                    position: relative;
                    &::before {
                        content: '';
                        display: inline-block;
                        position: absolute;
                    }
                }
                .time {
                    &::before {
                        top: 0.075rem;
                        left: -0.325rem;
                        width: 0.25rem;
                        height: 0.23rem;
                        background: url('./image/time.png') no-repeat center;
                        background-size: cover;
                    }
                }
                .desc {
                    margin-top: 0.21rem;
                    &::before {
                        top: 0.075rem;
                        left: -0.3rem;
                        width: 0.21rem;
                        height: 0.22rem;
                        background: url('./image/tip.png') no-repeat center;
                        background-size: cover;
                    }
                }
            }
        }
    }
    &:not(.isH5) {
        box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.05);
        .list {
            background-color: #fff;
            padding: 0.3rem .60rem 0.4rem;
            border-radius: .2rem;
            height: 100%;
            max-height: 4.68rem;
            overflow-y: auto !important;
            .item {
                padding: 0.14rem 0 0.1rem;
                & + .item {
                    border-top: 0.01rem solid #9f9f9f;
                }
                .box {
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                }
            }
            .title {
                margin-bottom: .05rem;
                line-height: .34rem;
                font-size: .22rem;
                color: #262626;
            }
            .btn {
                position: relative;
                top: 0.1rem;
                margin-left: 0.2rem;
                flex-shrink: 0;
                line-height: 0.4rem;
                padding: 0 0.2rem;
                font-size: 0.16rem;
                color: #ff6900;
                min-width: 0.9rem;
                border-radius: 0.21rem;
                text-align: center;
                border: 0.02rem solid #ff6900;
            }
            .empty {
                padding: 0.60rem 0;
                text-align: center;
                font-size: .26rem;
                line-height: .40rem;
                color: #9f9f9f;
            }
            .fold-btn {
                line-height: 0.24rem;
                font-size: 0.16rem;
                color: #7a7a7a;
                &::after {
                    margin-left: 0.06rem;
                    position: relative;
                    top: -0.01rem;
                    content: '';
                    display: inline-block;
                    width: 0.10rem;
                    height: 0.06rem;
                    background: url('./image/arrow.png') no-repeat center;
                    background-size: contain;
                }
                &.is-fold {
                    &::after {
                        transform: rotate(180deg);
                    }
                }
            }
            .detail {
                margin-top: 0.12rem;
                padding: 0.17rem 0.6rem 0.2rem 0.6rem;
                background-color: #f8f8f8;
                border-radius: 0.1rem;
                border: 0.01rem solid #efefef;
                position: relative;
                &::before {
                    position: absolute;
                    top: -0.13rem;
                    left: 0.49rem;
                    content: '';
                    display: inline-block;
                    width: 0.27rem;
                    height: 0.27rem;
                    background: url('./image/triangle.png') no-repeat center;
                    background-size: contain;
                }
                .time, .desc {
                    line-height: 0.24rem;
                    font-size: 0.16rem;
                    color: #7a7a7a;
                    position: relative;
                    &::before {
                        content: '';
                        display: inline-block;
                        position: absolute;
                    }
                }
                .time {
                    &::before {
                        top: 0.035rem;
                        left: -0.325rem;
                        width: 0.18rem;
                        height: 0.18rem;
                        background: url('./image/time.png') no-repeat center;
                        background-size: contain;
                    }
                }
                .desc {
                    margin-top: 0.08rem;
                    &::before {
                        top: 0.035rem;
                        left: -0.3rem;
                        width: 0.17rem;
                        height: 0.17rem;
                        background: url('./image/tip.png') no-repeat center;
                        background-size: contain;
                    }
                }
            }
        }
    }
}
</style>
